import { setUserSessionPayload } from "../slices/otpAuthSlice";
import { store } from "../stores/store";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import moment from "moment";

const GUEST_TOKEN_KEY = "guestToken";
const LOGIN_EMAIL_KEY = "agavianLoginEmail";

const normalizeEmail = (email) => {
  if (typeof email !== "string") return "";

  const normalizedEmail = email.trim().toLowerCase();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)
    ? normalizedEmail
    : "";
};

export const saveLoginEmail = (email) => {
  try {
    if (typeof window === "undefined") return;

    const normalizedEmail = normalizeEmail(email);
    if (!normalizedEmail) return;

    window.localStorage.setItem(LOGIN_EMAIL_KEY, normalizedEmail);
  } catch (error) {
    console.log("Error in saveLoginEmail:", error);
  }
};

export const getStoredLoginEmail = () => {
  try {
    if (typeof window === "undefined") return "";

    return normalizeEmail(window.localStorage.getItem(LOGIN_EMAIL_KEY) || "");
  } catch (error) {
    console.log("Error in getStoredLoginEmail:", error);
    return "";
  }
};

export const removeStoredLoginEmail = () => {
  try {
    if (typeof window === "undefined") return;

    window.localStorage.removeItem(LOGIN_EMAIL_KEY);
  } catch (error) {
    console.log("Error in removeStoredLoginEmail:", error);
  }
};

// ✅ Save token in cookie
export const saveToken = ({ token, refreshToken, email }) => {
  try {
    console.log("tokens", token, refreshToken);
    Cookies.set("token", token, {
      expires: 7, // Expires in 7 days
      secure: true, // Works only over HTTPS
      sameSite: "strict", // Prevent CSRF attacks
      path: "/", // Accessible site-wide
    });

    Cookies.set("refreshToken", refreshToken, {
      expires: 7, // Expires in 7 days
      secure: true, // Works only over HTTPS
      sameSite: "strict", // Prevent CSRF attacks
      path: "/", // Accessible site-wide
    });

    let payload = {};
    try {
      payload = token ? jwt_decode(token) : {};
    } catch {
      payload = {};
    }

    saveLoginEmail(
      email ||
        payload?.email ||
        payload?.emailId ||
        payload?.userEmail ||
        payload?.mail ||
        payload?.sub ||
        "",
    );
  } catch (error) {
    console.log("Error in saveToken:", error);
  }
};

// ✅ Get token from cookie
export const saveGuestToken = (guestToken) => {
  try {
    if (!guestToken) return;

    Cookies.set(GUEST_TOKEN_KEY, guestToken, {
      expires: 7,
      secure: true,
      sameSite: "strict",
      path: "/",
    });
  } catch (error) {
    console.log("Error in saveGuestToken:", error);
  }
};

export const getToken = (key) => {
  try {
    const token = Cookies.get(key);
    console.log("Token:", token);
    return token;
  } catch (error) {
    console.log("Error in getToken:", error);
    return null;
  }
};

// ✅ Decode token payload (from cookie)
export const getGuestToken = () => getToken(GUEST_TOKEN_KEY);

export const removeGuestToken = () => {
  try {
    Cookies.remove(GUEST_TOKEN_KEY);
  } catch (error) {
    console.log("Error in removeGuestToken:", error);
  }
};

export const getGuestTokenParams = () => {
  const token = getToken("token");
  const guestToken = !token ? getGuestToken() : null;

  return guestToken ? { guestToken } : {};
};

export const withGuestTokenPayload = (payload = {}) => ({
  ...payload,
  ...getGuestTokenParams(),
});

export const getTokenPayload = (key) => {
  try {
    const token = getToken(key); // get from cookie
    const payload = token ? jwt_decode(token) : {};
    console.log("Payload:", payload);
    return payload;
  } catch (error) {
    console.log("Error in getTokenPayload:", error);
    return {};
  }
};

// ✅ Remove token from cookie
export const removeToken = () => {
  try {
    Cookies.remove("token");
    Cookies.remove("refreshToken");
    removeStoredLoginEmail();
    console.log("Token removed");
  } catch (error) {
    console.log("Error in removeToken:", error);
  }
};

// ✅ Check token expiry
export const checkTokenExpiry = () => {
  try {
    const token = Cookies.get("token");
    const payload = getTokenPayload("token");
    const { exp } = payload;

    if (!token || !exp) {
      store.dispatch(
        setUserSessionPayload({ ...payload, isTokenExpired: true }),
      );
      return null;
    }

    const expiryTime = moment.unix(exp);
    const now = moment();

    if (now.isAfter(expiryTime)) {
      console.log("Token is expired please login");
      removeToken();
      store.dispatch(
        setUserSessionPayload({ ...payload, isTokenExpired: true }),
      );
      return null;
    } else {
      saveLoginEmail(
        payload?.email ||
          payload?.emailId ||
          payload?.userEmail ||
          payload?.mail ||
          payload?.sub ||
          "",
      );
      store.dispatch(setUserSessionPayload({ ...payload, isTokenExpired: false }));
    }

    return token;
  } catch (err) {
    throw err;
  }
};

// ✅ Remove token from cookie and logout
export const removeTokenAndLogout = () => {
  try {
    removeToken();
    if (typeof window !== undefined) window.location.href = "/";
    console.log("Token removed");
  } catch (error) {
    console.log("Error in removeToken:", error);
  }
};
